import React from 'react';
import {connect} from 'react-redux';
import PollyPage from '../Pollies/PollyPage';
import {clearPage, fetchPage} from '../../actions/page';
import ElectionPage from "../Election/ElectionPage";
import PartyDetails from "../Party/PartyDetails";
import OrgDetails from "../Orgs/OrgDetails";
import TopicDetails from "../Topic/TopicDetails"
import LocationDetails from "../Location/LocationDetails"
import {getLabel} from "../../language";

export class PageLayout extends React.Component {
    constructor(props) {
        super(props);

        this.renderComponent = this.renderComponent.bind(this);
    }

    componentWillMount() {
        this.props.fetchPage(this.props.match.params.URLslug);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.page && this.props.page.page && (this.props.page.page.typePage === 'Organisation'|| this.props.page.page.typePage === 'Polly'|| this.props.page.page.typePage === 'Party') && this.props.match.params.URLslug !== nextProps.match.params.URLslug) {
            this.props.fetchPage(nextProps.match.params.URLslug);
        }
    }

    componentWillUnmount() {
        this.props.clearPage();
    }

    renderComponent() {
        if (this.props.page && this.props.page.page) {
            if (this.props.page.page?.status == 404) {
                return (
                    <div style={{background: 'white'}}>
                        <div>
                            <p className=" alert">{getLabel(336)}</p>
                        </div>
                    </div>);
            }
            switch (this.props.page.page.typePage) {
                case 'Polly':
                    return <PollyPage {...this.props} polly={this.props.page.page}
                                      commentId={this.props.location.state}/>;
                    break;

                case 'Election' :
                    return <ElectionPage {...this.props} election={this.props.page.page}
                                         commentId={this.props.location.state}/>
                    break;

                case 'Party' :
                    return <PartyDetails {...this.props} party={this.props.page.page}
                                         commentId={this.props.location.state}/>
                    break;

                case 'Organisation':
                    return <OrgDetails  {...this.props} Orgs={this.props.page.page}/>
                    break;

                case 'Topic':
                    return <TopicDetails {...this.props} topic={this.props.page.page}
                                         commentId={this.props.location.state}/>
                    break;
                case 'Location':
                    return <LocationDetails {...this.props} locationTag={this.props.page.page}
                                            commentId={this.props.location.state}/>
                    break;
            }
        }
        return null;
    };

    render() {
        return (
            <div>
                {this.renderComponent()}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    page: state.page
});

export default connect(mapStateToProps, {fetchPage, clearPage})(PageLayout);
